module.exports = __webpack_public_path__ + "img/cloudflare-logo.5a09fed8.png";